const state = {
  loadingPage: true,
  loadingInfoV4: false,
  processingTask: {
    isProcessing: false,
    msg: '',
  },
};

const getters = {
  loadingPage: (state) => {
    return state.loadingPage;
  },
  loadingInfoV4: (state) => {
    return state.loadingInfoV4;
  },
  processingTask: (state) => {
    return state.processingTask;
  },
};

const mutations = {
  UPDATE_LOADING_PAGE(state, loadingPage) {
    state.loadingPage = loadingPage;
  },
  UPDATE_LOADING_INFO_V4(state, loadingInfoV4) {
    state.loadingInfoV4 = loadingInfoV4;
  },
  UPDATE_PROCESSING_TASK(state, payload) {
    state.processingTask = payload;
  },
};

const actions = {
  updateLoadingPage({ commit }, payload) {
    commit("UPDATE_LOADING_PAGE", payload);
  },
  updateLoadingInfoV4({ commit }, payload) {
    commit("UPDATE_LOADING_INFO_V4", payload);
  },
  updateProcessingTask({ commit }, payload) {
    commit("UPDATE_PROCESSING_TASK", payload);  
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
